import React from "react";
import { Flex } from "@fluentui/react-northstar";

import Welcome from "./message/Welcome";

export default function Tab() {
  return (
  <div>
    <Welcome />
  </div>
  )
}
